export default __webpack_public_path__ + "static/media/s7.fc8ee257.jpg";